import ClassNames from "classnames";
import { FunctionComponent, useRef } from "react";
import styles from "../stylesheets/components/booking-widget.module.css";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import {
  BookingWidgetSettings,
  WidgetInstance,
  WindowState,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import HgvWidgetContainer from "./HgvWidgetContainer.js";

interface Props {
  settings: BookingWidgetSettings;
  className?: string;
}

const BookingWidget: FunctionComponent<Props> = ({ className, settings }) => {
  const ref = useRef<HTMLDivElement>(null);
  const widgetInstanceRef = useRef<WidgetInstance>(undefined);

  const initWidget = () => {
    if (!ref.current) return;

    const { BookingSüdtirol } = window as unknown as WindowState;
    widgetInstanceRef.current = BookingSüdtirol.Widgets.Booking(
      ref.current,
      settings,
    );
  };

  return (
    <div
      className={ClassNames(
        moduleBaseStyles.Module__Wrapper,
        className,
        css({ background: settings.colorScheme.main.background }),
      )}
    >
      <HgvWidgetContainer
        widgetInstance={widgetInstanceRef.current}
        initWidget={initWidget}
        settings={settings}
        enableLazyload={true}
      >
        <div className={styles.BookingWidget__Container} ref={ref} />
      </HgvWidgetContainer>
    </div>
  );
};

export default BookingWidget;
